import _slicedToArray from "/drone/src/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useDidUpdateEffect } from "./armor-system-HVGMTIMI.js";

// src/hooks/useControlledState.ts
import { useCallback as useCallback2, useState } from "react";

// src/hooks/useControlledFlagState.ts
import { useCallback } from "react";
var useControlledFlagState = function useControlledFlagState(defaultValue, value, onValueUpdate) {
  var _useControlledState = useControlledState(defaultValue, value, onValueUpdate),
    _useControlledState2 = _slicedToArray(_useControlledState, 2),
    realValue = _useControlledState2[0],
    setRealValue = _useControlledState2[1];
  var turnOn = useCallback(function () {
    setRealValue(true);
  }, [setRealValue]);
  var turnOff = useCallback(function () {
    setRealValue(false);
  }, [setRealValue]);
  var toggle = useCallback(function () {
    setRealValue(!realValue);
  }, [setRealValue, realValue]);
  return [realValue, setRealValue, turnOn, turnOff, toggle];
};

// src/hooks/useControlledState.ts
var useControlledState = function useControlledState(defaultValue, value, onChange) {
  var _useState = useState(defaultValue),
    _useState2 = _slicedToArray(_useState, 2),
    internalValue = _useState2[0],
    setInternalValue = _useState2[1];
  var realValue = value === void 0 ? internalValue : value;
  var isControlled = value !== void 0;
  var setRealValue = useCallback2(function (newValue) {
    onChange == null ? void 0 : onChange(newValue);
    if (value === void 0) {
      setInternalValue(newValue);
    }
  }, [setInternalValue, onChange, value]);
  useDidUpdateEffect(function () {
    return setInternalValue(defaultValue);
  }, [defaultValue]);
  return [realValue, setRealValue, isControlled];
};
export { useControlledState, useControlledFlagState };